<template>
  <div class="error-container white mt-5">
    <center><img class="error-logo" src="@/assets/img/logo-md.png" /></center>
    <div class="row error-block mt-5">
      <div class="col-sm-2" />
      <div class="text-left col-sm-8">
        <h1 class="error-title">Disabled Account</h1>
        <h4 class="error-content">
          This account has been disabled. If you think this an error, contact
          us.
        </h4>
        <div class="text-center mt-5">
          <v-btn
            outlined
            large
            class="ml-3"
            href="mailto:support@sustainesolutions.com?subject=Sustaine%20Error%20500"
            >Contact Us</v-btn
          >
        </div>
      </div>
      <div class="col-sm-2" />
    </div>
  </div>
</template>
<script>
export default {
  // == Name
  name: 'DisabledAccount'
}
</script>
<style lang="scss" scoped>

/* error pages */
.error-container {
  a:link,
  a:visited,
  a:hover,
  a:active {
    color: white !important;
  }
  color: white !important;
  height: 100%;
  padding: 2em 0 4em 0;

  .error-block {
    background-color: #5280c5 !important;
    padding: 4em 0 4em 0;
    color: white;
  }

  @media only screen and (min-device-width: 320px) {
    .error-logo {
      width: 200px;
    }
    .error-title {
      font-size: 20px !important;
    }
    .error-content {
      font-size: 14px !important;
    }
  }
  @media only screen and (min-device-width: 480px) {
    .error-logo {
      width: 300px;
    }
    .error-title {
      font-size: 20px !important;
    }
    .error-content {
      font-size: 14px !important;
    }
  }
  @media only screen and (min-device-width: 768px) {
    .error-logo {
      width: 400px;
    }
    .error-title {
      font-size: 24px !important;
    }
    .error-content {
      font-size: 20px !important;
    }
  }
}
</style>